import React from 'react';
import formatDistanceToNow from "date-fns/formatDistanceToNow";

const Comment = ({className = '', name, avatar, date, body, attachment, attachmentPreview}) => {
    return (
        <div className={`${className} bg-blur bg-black p-4 bg-opacity-75 hover:bg-opacity-100 rounded-xl`}>
            <div className="mb-2 flex items-center">
                <div className="w-10 mr-3">
                    {avatar ? (
                        <img className="w-10 h-10 object-center rounded-full" alt="Avatar" src={avatar} width={200} height={200} />
                    ) : (
                        <span className="w-10 h-10 rounded-full bg-yellow-600 flex items-center justify-center">
                            <i className="fas fa-fw fa-user text-white text-2xl"  />
                        </span>
                    )}
                </div>
                <div className="flex-grow">
                    <h4 className="font-bold text-white tracking-tight">{name}</h4>
                    <p className="text-gray-400 text-sm">
                      {formatDistanceToNow(new Date(date), {addSuffix: true})}
                    </p>
                </div>
            </div>
            <div className={`text-gray-200`} >
                <p dangerouslySetInnerHTML={{__html: body.replace(/(?:\r\n|\r|\n)/g, '<br />')}} />
                {attachment && (
                    <div className="mt-2">
                        <h6 className="mb-2 inline-block text-2xs uppercase bg-gray-600 rounded tracking-wide font-bold px-1 leading-loose text-white-50">Attachment</h6>
                        <div className="w-full">
                            <a className="inline-block relative" href={attachment} target="_blank">
                            <span className="absolute z-20 bg-black w-full h-full flex items-center justify-center bg-opacity-50 transition-opacity opacity-0 hover:opacity-100">
                                <i className="fas fa-fw fa-external-link" />
                            </span>
                            <img className="h-auto w-auto rounded-lg overflow-hidden" alt="Attachment" src={attachmentPreview} />
                            </a>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Comment;
